import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import api from "../../../Component/axios_Interceptor/api";
import url from "../../../Component/server";
import { live_info_type } from "../../User/Live/Live";

const Container = styled.div`
  width: 100%;
  height: 100%;
  margin-right: 1rem;
  margin-bottom: 1rem;
  background-color: #3a3939;
  overflow: hidden;
  box-sizing: border-box;
  position: absolute;
`;
const LiveContent = styled.div`
  width: 100%;
  height: 100%;
  background-color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  canvas {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

// LiveBox 컴포넌트
interface Live_Props {
  livestart: string;
  selectedVideo_props: string;
  selectedAudio_props: string;
  live_info: live_info_type | undefined;
}

const AdminLive = ({
  livestart,
  selectedAudio_props,
  selectedVideo_props,
  live_info,
}: Live_Props) => {
  // const [videoDevices, setVideoDevices] = useState<MediaDeviceInfo[]>([]);
  // const [audioDevices, setAudioDevices] = useState<MediaDeviceInfo[]>([]);
  // const [ingestEndpoint, setIngestEndpoint] = useState<string>(
  //   "rtmps://c0d177424d25.global-contribute.live-video.net:443/app/"
  // );
  // const [streamKey, setStreamKey] = useState<string>(
  //   "sk_ap-northeast-2_4opYgLehXWSG_baSwbFoFrgihjfvXybFK0C46IZTtrX"
  // );

  const [isLive, setIsLive] = useState(false); // 라이브 상태 관리
  const [selectedVideo, setSelectedVideo] = useState<string>("");
  const [selectedAudio, setSelectedAudio] = useState<string>("");
  const [mediaStream, setMediaStream] = useState<MediaStream | null>(null); // MediaStream 상태 추가
  const [client, setClient] = useState<any>(null); // IVS 클라이언트 상태 추가
  const previewRef = useRef<HTMLCanvasElement | null>(null); // canvas 요소 레퍼런스

  useEffect(() => {
    // Amazon IVS SDK 동적 로드
    const script = document.createElement("script");
    script.src =
      "https://web-broadcast.live-video.net/1.16.0/amazon-ivs-web-broadcast.js";
    script.async = true;
    document.body.appendChild(script);

    // script.onload = async () => {
    // await initializeDeviceSelect();
    // };
    return () => {
      document.body.removeChild(script); // cleanup
    };
  }, []);

  // 장치 초기화
  // const initializeDeviceSelect = async () => {
  // const devices = await navigator.mediaDevices.enumerateDevices();
  // const videoDevices = devices.filter((d) => d.kind === "videoinput");
  // const audioDevices = devices.filter((d) => d.kind === "audioinput");
  // setVideoDevices(videoDevices);
  // setAudioDevices(audioDevices);
  // };

  const StreamInfo = async () => {
    try {
      const res = await api.post(url.Communication_url.getStreamInfo, {
        live_seq: live_info?.seq,
      });
      if (res.data.length === 0) {
        alert("방송서버와 연결되지 않았습니다. (키값이 없습니다)");
        return;
      }
      if (client && client.startBroadcast) {
        client.startBroadcast(res.data.streamKey, res.data.I_Epoint);
      }
    } catch (err) {
      console.error("streaminfoErr", err);
    }
  };

  useEffect(() => {
    if (isLive) StreamInfo();
  }, [client]);

  // 방송 중지
  const stopBroadcast = async () => {
    try {
      if (mediaStream) {
        mediaStream.getTracks().forEach((track) => track.stop());
        setMediaStream(null); // MediaStream 상태 초기화
      }

      if (client) {
        await client.stopBroadcast();
        client.detachPreview(previewRef.current!); // 프리뷰 연결 해제
        setClient(null); // 클라이언트 인스턴스를 null로 설정
      }

      // canvas 내용 지우기
      const canvas = previewRef.current;
      if (canvas) {
        const context = canvas.getContext("2d");
        if (context) {
          context.clearRect(0, 0, canvas.width, canvas.height); // canvas 클리어
        }
      }

      setIsLive(false);
    } catch (err) {
      console.log("방송종료에러", err);
    }
  };

  // 방송 시작
  // 방송 프리뷰 초기화 (Amazon IVS의 attachPreview 사용)
  const startBoardcast_init = async () => {
    if (!selectedVideo || !selectedAudio) {
      // 오디오 미설정
      return;
    }
    if (!window.IVSBroadcastClient) {
      // IVS Broadcast Client SDK load 실패
      return;
    }

    setIsLive(true);
    console.log("방송 시작 중...");

    const newClient = window.IVSBroadcastClient.create({
      streamConfig: window.IVSBroadcastClient.BASIC_FULL_HD_LANDSCAPE, // 기본 방송 설정
    });
    console.log("미디어 장치 연결 중...");

    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { deviceId: { exact: selectedVideo } },
        audio: { deviceId: { exact: selectedAudio } },
      });

      // MediaStream 상태 저장
      setMediaStream(stream);

      // console.log("MediaStream 객체:", stream);
      // console.log("MediaStream의 비디오 트랙:", stream.getVideoTracks());

      if (!(stream instanceof MediaStream)) {
        throw new Error("반환된 객체는 MediaStream이 아닙니다."); // 종료
      }

      newClient.addVideoInputDevice(stream, "Webcam", { index: 0 });
      newClient.addAudioInputDevice(stream, "Microphone");

      console.log("프리뷰 캔버스에 연결 중...");

      // 기존 클라이언트 인스턴스가 있을 경우 연결 해제
      if (client) {
        client.detachPreview(previewRef.current!);
      }

      // 프리뷰 캔버스가 유효한지 확인
      if (previewRef.current) {
        newClient.attachPreview(previewRef.current);
        console.log("프리뷰 연결 완료");
      } else {
        console.error("프리뷰 캔버스가 유효하지 않습니다.");
      }
      // 새로운 클라이언트 인스턴스를 상태로 저장
      setClient(newClient);
    } catch (err) {
      console.error("미디어 장치 연결 실패:", err);
    }
  };

  useEffect(() => {
    if (livestart === "start") {
      startBoardcast_init();
    } else {
      stopBroadcast();
    }
  }, [livestart]);

  useEffect(() => {
    setSelectedVideo(selectedVideo_props);
  }, [selectedVideo_props]);

  useEffect(() => {
    setSelectedAudio(selectedAudio_props);
  }, [selectedAudio_props]);

  return (
    <Container translate="no">
      <LiveContent>
        <canvas ref={previewRef} width="100%" height="100%" />
      </LiveContent>
    </Container>
  );
};

export default AdminLive;
